import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const routesUser: RouteMetaConfig[] = [
  {
    path: '/users',
    name: routeNames.userOverview,
    component: () => import('./views/UserListView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'users.view',
    },
    children: [
      buildModalRoute(
        {
          name: routeNames.userCreate,
          path: 'create',
          meta: {
            requiresAuth: true,
            permission: 'users.create',
          },
          component: () => import('./views/UserCreateFormView.vue'),
        },
        { fullscreen: true }
      ),
    ],
  },
  {
    path: '/users/:id(\\d+)',
    name: routeNames.userDetails,
    component: () => import('./views/UserDetailView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'users.view',
    },
    children: [
      buildModalRoute(
        {
          path: 'edit/general',
          name: routeNames.userEditGeneral,
          meta: {
            requiresAuth: true,
            permission: 'users.update',
          },
          component: () => import('./views/UserEditGeneralForm.vue'),
        },
        { fullscreen: false }
      ),
    ],
  },
];

export const userRoutesFactory = {
  userDetails(id: number | string) {
    return {
      name: routeNames.userDetails,
      params: {
        id,
      },
    };
  },
};
